import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { isNative } from "@/lib/capacitor";

/**
 * Thin haptics wrapper — no-ops on web, calls into the native Capacitor
 * plugin on Android / iOS. Used by Cooking Mode on every step transition
 * (BRD §3.4) and when a timer fires.
 */
export function useHaptics() {
  return {
    tick: () => void run(() => Haptics.impact({ style: ImpactStyle.Light })),
    step: () => void run(() => Haptics.impact({ style: ImpactStyle.Medium })),
    complete: () =>
      void run(() =>
        Haptics.notification({ type: NotificationType.Success }),
      ),
    alert: () =>
      void run(() => Haptics.notification({ type: NotificationType.Warning })),
  };
}

async function run(fn: () => Promise<void>): Promise<void> {
  if (!isNative()) return;
  try {
    await fn();
  } catch {
    // Plugin not registered for this platform — ignore.
  }
}
